import { ProductEntry, SubscriptionInfoContainer } from '../../../store/api';
import { formatUsageLimit } from '../../utils/formatUsageLimit';
import { mapIssueUsageOverviewAndShared } from './mapIssueUsage';
import { ExtendedManageLineShared, ExtendedManageLineUsageLimit } from '../types/ExtendedManageLineShared';
import { issueNotDeliveredYet } from '../types/IssueUsage';
import i18n from '../../../../i18n';

const hasCurrentYearSubscription = (currentSubscriptions?: SubscriptionInfoContainer) =>
    currentSubscriptions && currentSubscriptions.sharedUsageLimit != null;

export const mapExtendedShared = (item: ProductEntry): ExtendedManageLineShared => {
    const { currentSubscriptions, nextSubscriptions, previousIssueStatistics, currentIssueStatistics } = item;

    return {
        currentYearSubscription: hasCurrentYearSubscription(currentSubscriptions)
            ? {
                  type: ExtendedManageLineUsageLimit.Value,
                  label: formatUsageLimit(currentSubscriptions?.sharedUsageLimit),
                  stockDetails: currentSubscriptions?.stockDetails.shared!
              }
            : {
                  type: ExtendedManageLineUsageLimit.None,
                  label: i18n.t('shop.subscriptions.noSharedSubscription')
              },

        previousIssueUsage: hasSubscription(currentSubscriptions)
            ? previousIssueStatistics.shared
                ? mapIssueUsageOverviewAndShared(
                      previousIssueStatistics.shared,
                      hasCurrentYearSubscription(currentSubscriptions) ?? false
                  )
                : issueNotDeliveredYet
            : undefined,

        currentIssueUsage: hasSubscription(currentSubscriptions)
            ? currentIssueStatistics.shared
                ? mapIssueUsageOverviewAndShared(
                      currentIssueStatistics.shared,
                      hasCurrentYearSubscription(currentSubscriptions) ?? false
                  )
                : issueNotDeliveredYet
            : undefined,

        nextYearSubscription:
            nextSubscriptions && nextSubscriptions.sharedUsageLimit != null
                ? {
                      type: ExtendedManageLineUsageLimit.Value,
                      label: formatUsageLimit(nextSubscriptions.sharedUsageLimit),
                      stockDetails: nextSubscriptions?.stockDetails.shared!
                  }
                : hasCurrentYearSubscription(currentSubscriptions)
                ? {
                      type: ExtendedManageLineUsageLimit.NotRenewed,
                      label: i18n.t('shop.subscriptions.notRenewedYet')
                  }
                : {
                      type: ExtendedManageLineUsageLimit.None,
                      label: i18n.t('shop.subscriptions.noSharedSubscription')
                  }
    };
};

const hasSubscription = (subscription?: SubscriptionInfoContainer) => subscription?.sharedUsageLimit != null;
